import { types } from '../types/loadingTypes';

const show = () => {
	return {
		type: types.show,
		show: true,
	};
};
const close = () => {
	return {
		type: types.close,
		show: false,
	};
};

export const loadingActions = {
	show,
	close,
};
